import { Typography } from '@material-ui/core';
import { useStyles } from './button-keyboard-string-styles';
import { ButtonKeyboardProps } from './button-keyboard-string-props';

export function ButtonKeyboardString(props: ButtonKeyboardProps) {
  const classes = useStyles();

  return (
    <div
      className={`${classes.ButtonKeyboardContainer}`}
      onClick={() => {
        if (props.value !== null && props.value !== undefined)
          props.clickFunc(props.value);
        else if (props.label !== null) props.clickFunc(props.label);
      }}
    >
      <Typography
        className={classes.TypographyButtonKeyboard}
        variant={props.textVariant !== undefined ? props.textVariant : 'h5'}
      >
        {` ${props.label !== undefined ? props.label : props.value} ${
          props.prefix !== undefined ? props.prefix : ''
        }`}
      </Typography>
    </div>
  );
}
